import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { OrderProductNote } from './components/OrderProductNote/OrderProductNote';
import { OrderProductExclusions } from './containers/OrderProductExclusions/OrderProductExclusions';
import { OrderProductHeader } from './containers/OrderProductHeader/OrderProductHeader';
import { OrderProductItemsList } from './containers/OrderProductItemsList/OrderProductItemsList';
import { OrderProductModifiers } from './containers/OrderProductModifiers/OrderProductModifiers';
import { PRODUCT_TYPE } from '~/types/product';
import { IOrderProduct } from 'src/types/orders';
import './style.scss';

interface IProps {
  product: IOrderProduct;
}

export const OrderProduct: React.FC<IProps> = observer(({ product }: IProps): JSX.Element => {
  const isMeal = useMemo((): boolean => product.type === PRODUCT_TYPE.MEAL_COMBO, [product.type]);

  return (
    <div className="order-product">
      <OrderProductHeader product={product} />

      <OrderProductModifiers modifiers={product.modifiers} productQuantity={product.quantity} />
      <OrderProductExclusions exclusions={product.exclusions} />
      <OrderProductItemsList items={product.items} isMeal={isMeal} productQuantity={product.quantity} />

      <OrderProductNote notes={product.notes} />
    </div>
  );
});
